import Svg from 'images/svg/half-circled-shape.svg';
import styled from 'styled-components';
import { mediaBreakpointDown, mediaBreakpointUp } from 'utils/styledCssHelpers';

export const HalfCircleSvg = styled(Svg)`
  transform: rotate(${props => props.rotate || '0'})
    translateY(${props => props.$moveY || '-240px'}) scale(1);
  position: absolute;
  z-index: -2;
  display: block;
  right: 0;
  top: 0;
  width: 100vw;

  ${mediaBreakpointUp(
    'sm',
    `
         
 
    transform: translateY(-200px);
  `,
  )};

  ${mediaBreakpointUp(
    'md',
    `

    transform: translateX(0) translateY(-200px);
  `,
  )};
  ${mediaBreakpointUp(
    'lg',
    `

    transform: translateX(0) translateY(-150px);
  `,
  )};
  ${mediaBreakpointUp(
    'xl',
    `
    transform: translateX(0) translateY(-120px);
  `,
  )};
  ${mediaBreakpointUp(
    'xxl',
    `
    transform: translateY(100px) translateX(-340px) scale(1.35);
    width: unset;
    
  `,
  )};
`;
